const currencies = {
	usd: '$',
	rub: '₽',
	idr: 'idr',
	byn: 'бел.руб',
	kgs: 'сом',
	kzt: 'тнг',
	mdl: 'леи',
	azn: 'azn',
	gel: 'лари',
	bef: 'bef',
	sek: 'sek',
	omr: 'omr',
	uah: 'грн',
	ron: 'ron',
	thb: '฿',
	amd: 'amd',
	eur: '€',
	uzs: 'сўм',
	huf: 'Ft',
	pln: 'zł',
	bgn: 'лв',
	czk: 'czk',
	hrk: 'hrk',
	sgd: 'sgd',
	cdf: 'cdf',
	zar: 'zar',
	rwf: 'rwf',
	kes: 'kes',
	clp: 'clp',
	jod: 'jod',
	bhd: 'bhd',
	cfa: 'cfa',
	mxn: '$',
	myr: 'myr',
	nio: 'nio',
	sar: 'sar',
	iqd: 'iqd',
	chf: 'chf',
	cop: 'cop',
	vnd: '₫',
	lbp: 'ل.ل.',
	ngn: '₦',
	aed: 'د.إ',
	all: 'lekë',
	inr: '₹',
	bdt: '৳',
	twd: 'NT$',
	mmk: 'K',
	php: '₱',
	lkr: '₨',
	try: '₺',
	kwd: 'د.ك',
	brl: 'brl',
	gtq: 'gtq',
	bob: 'bob',
	sol: 'sol',
	qar: 'qar',
	ars: 'ars'
};

const lower = Object.keys(currencies).reduce((memo, k) => Object.assign(memo, { [k]: k }), { });
const upper = Object.keys(currencies).reduce((memo, k) => Object.assign(memo, { [k]: k.toUpperCase() }), { });

module.exports = {
	enum: lower,
	locale: {
		ru: currencies,
		en: lower,
		uk: lower,
		de: upper,
		vi: lower,
		th: upper
	}
};



// WEBPACK FOOTER //
// ./enums/currencies.js